import React, { useEffect, useState } from "react";
import { Divider, IconButton, Tooltip } from "@mui/material";
import { debounce, isEmpty } from "lodash";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";

//Styles
import { customStyles } from "../../../../components/common/customStyleSelect";

// Icons
import { MdFilterList, MdSearch } from "react-icons/md";
import { Button, Form } from "react-bootstrap";
import { BsSliders } from "react-icons/bs";
import Icon from "@mdi/react";
import { mdiFilterVariant, mdiRestore } from "@mdi/js"; // Icons

// Redux
import {
  setKeywords,
  setSelectDraft,
} from "../../../../redux/slices/reports/projectReportsSlice";

const Filters = ({
  handleShowCanvas,
  yearValue,
  setYearValue,
  monthValue,
  setMonthValue,
  handleReset,
}) => {
  const dispatch = useDispatch();

  const { activeRmk, searchRmk, keywords, isLoading, selectDraft } = useSelector(
    (state) => ({
      activeRmk: state.rmkReducer.activeRmk,
      searchRmk: state.reportReducer.searchRmk,
      keywords: state.reportReducer.projects.keywords,
      selectDraft: state.reportReducer.selectDraft,
      isLoading: state.reportReducer.isLoading.projects,
    }),
  );

  // Use searchRmk if selected, otherwise use activeRmk
  const currentRmk = searchRmk || activeRmk;

  const [yearOptions, setYearOptions] = useState([]);

  const monthOptions = [
    { value: 1, label: "Januari" },
    { value: 2, label: "Februari" },
    { value: 3, label: "Mac" },
    { value: 4, label: "April" },
    { value: 5, label: "Mei" },
    { value: 6, label: "Jun" },
    { value: 7, label: "Julai" },
    { value: 8, label: "Ogos" },
    { value: 9, label: "September" },
    { value: 10, label: "Oktober" },
    { value: 11, label: "November" },
    { value: 12, label: "Disember" },
  ];

  const handleSearch = (text) => {
    dispatch(setKeywords(text));
  };

  const handleViewDraft = () => {
    if (selectDraft === false) {
      dispatch(setSelectDraft(null));
    } else {
      dispatch(setSelectDraft(false));
    }
  };

  useEffect(() => {
    if (!isEmpty(currentRmk)) {
      const { first_year, second_year, third_year, fourth_year, fifth_year } =
        currentRmk;

      const options = [
        first_year,
        second_year,
        third_year,
        fourth_year,
        fifth_year,
      ];

      setYearOptions(options);
      
      // Set year to current year if it's within the RMK range, otherwise use first year of RMK
      const yearNow = new Date().getFullYear();
      if (options.includes(yearNow)) {
        setYearValue(String(yearNow));
      } else {
        // Use the latest year in the RMK range
        setYearValue(String(fifth_year || first_year));
      }
    }
  }, [currentRmk]);

  return (
    <div className='d-flex align-items-center gap-3 mb-3'>
      <div className='remove-outline-item'>
        <Tooltip title='Lebih Pilihan' placement='top' arrow>
          <Button variant='secondary' onClick={handleShowCanvas}>
            <Icon path={mdiFilterVariant} size={0.8} />
          </Button>
        </Tooltip>
      </div>

      <div className='search-box-custom'>
        <div className='position-relative'>
          <label htmlFor='search-bar-0' className='search-label-custom'>
            <input
              type='text'
              className='form-control'
              placeholder='Cari nama projek...'
              value={keywords}
              onChange={(e) => handleSearch(e.target.value)}
              style={{ width: 250 }}
              disabled={isLoading}
            />
          </label>
          <MdSearch className='search-icon-2' size={18} />
        </div>
      </div>

      <Form.Group>
        <Form.Select
          value={yearValue}
          onChange={(e) => {
            const year = String(e.target.value);
            setYearValue(year);
          }}
        >
          <option value=''>5 Tahun</option>
          {yearOptions.map((year) => (
            <option key={year} value={year}>
              {`Tahun ${year}`}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      <Form.Group>
        <Form.Select
          value={monthValue}
          onChange={(e) => {
            const month = e.target.value;
            setMonthValue(month);
          }}
          disabled={!yearValue}
        >
          <option value=''>Semua Bulan</option>
          {monthOptions.map((month) => (
            <option key={month.value} value={month.value}>
              {month.label}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      <Form.Group>
        <Button
          variant={selectDraft === false ? "secondary" : "outline-secondary"}
          onClick={handleViewDraft}
        >
          Draf
        </Button>
      </Form.Group>

      <div className='align-self-center'>
        <div onClick={handleReset} style={{ cursor: "pointer" }}>
          <Icon path={mdiRestore} size={1} />
        </div>
      </div>
    </div>
  );
};

export default Filters;
